import {
  ViewPage,
} from 'src/views/onboardwhitelabelparty'
import pathMap from 'src/paths/pathMap'

class OnBoardWhiteLabelPartyRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ON_BOARD_WHITE_LABEL_PARTY_LIST_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default OnBoardWhiteLabelPartyRoute
